import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { LogOut, FolderOpen, Inbox, Settings, Star, Gift, Video, MessageSquare } from 'lucide-react';

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const userData = localStorage.getItem('admin_user');
    if (userData) {
      setUser(JSON.parse(userData));
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_user');
    navigate('/admin/login');
  };

  const cards = [
    {
      title: 'Manage Projects',
      description: 'Add, edit, or delete projects',
      icon: <FolderOpen size={40} />,
      link: '/admin/projects',
      color: 'bg-blue-50 border-blue-200',
      iconColor: 'text-blue-600',
    },
    {
      title: 'Offers & Flyers',
      description: 'Create festive promotions',
      icon: <Gift size={40} />,
      link: '/admin/offers',
      color: 'bg-purple-50 border-purple-200',
      iconColor: 'text-purple-600',
    },
    {
      title: 'Customer Speaks',
      description: 'Video testimonials',
      icon: <Video size={40} />,
      link: '/admin/video-testimonials',
      color: 'bg-red-50 border-red-200',
      iconColor: 'text-red-600',
    },
    {
      title: 'Testimonials',
      description: 'Written reviews & photos',
      icon: <Star size={40} />,
      link: '/admin/testimonials',
      color: 'bg-yellow-50 border-yellow-200',
      iconColor: 'text-yellow-600',
    },
    {
      title: 'View Enquiries',
      description: 'Customer leads',
      icon: <Inbox size={40} />,
      link: '/admin/enquiries',
      color: 'bg-green-50 border-green-200',
      iconColor: 'text-green-600',
    },
    {
      title: 'Customer Feedback',
      description: 'Booking & handover feedback',
      icon: <MessageSquare size={40} />,
      link: '/admin/feedback',
      color: 'bg-amber-50 border-amber-200',
      iconColor: 'text-amber-600',
    },
    {
      title: 'Site Settings',
      description: 'Logo, colors, content',
      icon: <Settings size={40} />,
      link: '/admin/settings',
      color: 'bg-gray-50 border-gray-200',
      iconColor: 'text-gray-600',
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <nav className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center gap-4">
              <Link to="/admin/dashboard" className="flex items-center gap-3">
                <img 
                  src="https://customer-assets.emergentagent.com/job_34f43037-f49f-4896-a120-3461406a9d35/artifacts/wh0yojmq_e30d7691-c116-46a6-b645-fa81d1964b10-removebg-preview.png" 
                  alt="Infinity Group" 
                  className="h-20 w-auto"
                />
                <div className="flex flex-col">
                  <span className="text-xl font-bold text-gray-900">Infinity Group</span>
                  <span className="text-xs italic text-gray-600">Dreams Unlimited</span>
                </div>
              </Link>
              <span className="ml-3 text-sm text-gray-500">Admin Panel</span>
            </div>
            <div className="flex items-center gap-4">
              {user && <span className="text-sm text-gray-600">Welcome, {user.full_name}</span>}
              <button
                onClick={handleLogout}
                className="flex items-center gap-2 text-gray-700 hover:text-red-600 transition-colors"
                data-testid="logout-btn"
              >
                <LogOut size={18} />
                <span>Logout</span>
              </button>
            </div>
          </div>
        </div>
      </nav>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-bold text-gray-900 mb-8" data-testid="dashboard-heading">
          Admin Dashboard
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {cards.map((card, index) => (
            <Link
              key={index}
              to={card.link}
              className={`${card.color} border-2 rounded-xl p-8 hover:shadow-lg transition-shadow`}
              data-testid={`dashboard-card-${index}`}
            >
              <div className={`${card.iconColor} mb-4`}>{card.icon}</div>
              <h2 className="text-2xl font-semibold text-gray-900 mb-2">{card.title}</h2>
              <p className="text-gray-600">{card.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;